import { ContentBox } from "@msuite/ui/app-shell";
import { Panels } from "@msuite/ui/panels";
import { useParams } from "react-router";
import { WikiPage } from "./wiki-page";
import { WikiSidebar } from "./wiki-sidebar";

export function Wiki() {
	/** Hooks */
	const { spaceId, pageId } = useParams<{ spaceId: string; pageId: string }>();

	/** Render */
	return (
		<ContentBox>
			<Panels resizable>
				<Panels.Panel flex={1}>
					<WikiSidebar
						spaceId={spaceId}
						pageId={pageId}
					/>
				</Panels.Panel>
				<Panels.Panel flex={3}>
					<WikiPage
						spaceId={spaceId}
						pageId={pageId}
					/>
				</Panels.Panel>
			</Panels>
		</ContentBox>
	);
}
